// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IApiGeoGeocodedForSearchRequest,
  TApiGeoGeocodedForSearchModel,
  IMappers,
  TApiGeoGeocodedForSearchResponse,
  IApiGeoGeocodedForSearchResponse,
} from './types';

export const defaultConfig: TApiGeoGeocodedForSearchModel = {
  apiType: 'legacy',
  assertStatusCodes: [200],
  hostType: 'api',
  method: 'POST',
  microserviceName: 'monolith-cian-realty',
  pathApi: '/api/geo/geocoded-for-search/',
  requestType: 'json',
} as TApiGeoGeocodedForSearchModel;

export function createApiGeoGeocodedForSearchModel(
  parameters: IApiGeoGeocodedForSearchRequest,
): TApiGeoGeocodedForSearchModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IApiGeoGeocodedForSearchOptions<TResponse200> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200>;
  parameters: IApiGeoGeocodedForSearchRequest;
}

export async function fetchApiGeoGeocodedForSearch<TResponse200>({
  httpApi,
  config,
  mappers,
  parameters,
}: IApiGeoGeocodedForSearchOptions<TResponse200>): Promise<TApiGeoGeocodedForSearchResponse | TResponse200> {
  const { statusCode, response, headers } = await httpApi.fetch(createApiGeoGeocodedForSearchModel(parameters), config);
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IApiGeoGeocodedForSearchResponse);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TApiGeoGeocodedForSearchResponse;
}
